var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('i',{staticClass:"bi bly-check"}),_c('h1',[_vm._v("Logged out successfully")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login again")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }